import { Alert } from 'antd';
import { useOnline } from '@/shared/lib/hooks';

/** Mounted once near the app root — shows while `navigator.onLine` is false. */
export function OfflineBanner() {
  const online = useOnline();

  if (online) return null;

  return (
    <Alert
      banner
      type="warning"
      showIcon
      message="Нет подключения к интернету"
      style={{ position: 'sticky', top: 0, zIndex: 1000 }}
    />
  );
}
